<script>
import Drawer from "@/components/drawer";
import appConfig from "@/app.config";
import PageHeader from "@/components/page-header";

import Swal from "sweetalert2";
import { required } from "vuelidate/lib/validators";
import Multiselect from "vue-multiselect";
import moment from "moment";
import draggable from "vuedraggable";
import Middleware from "@/helpers/middlewares";

// Data
import UserService from "@/helpers/APIService/user.service";
import { authComputed, authMethods } from "@/state/helpers";
import { payment_gateways } from "@/helpers/global.variable";

//Custom Components
import Terms from "@/components/accountSetup/terms.vue";
import PaymentPolicy from "@/components/accountSetup/paymentPolicy";
import CustomQuestion from "@/components/accountSetup/customQuestion.vue";
import Taxes from "@/components/accountSetup/taxes.vue";
import hotelService from "@/helpers/APIService/hotel.service";
import errorHandler from "@/helpers/errorHandler";

// Dashboard Component

const initPaymentGatewayObj = {
  payment_gateway_type: "macrotech",
  macrotech_tcai: "",
  macrotech_tcac: "",
  macrotech_omi: "",
  macrotech_omt: "",
  macrotech_emi: "",
  macrotech_emdi: "",
  stripe_access_token: "",
  stripe_refresh_token: "",
  stripe_publishable_key: "",
  stripe_user_id: "",
  stripe_token_type: "",
  stripe_scope: "",
  stripe_livemode: "",
  stripe_dashboard_name: "",
  stripe_account: "",
  is_active: false,
};

export default {
  page: {
    title: "Account Setup",
    meta: [
      {
        name: "description",
        content: appConfig.description,
      },
    ],
  },
  components: {
    PageHeader,
    Drawer,
    CustomQuestion,
    PaymentPolicy,
    Terms,
    Taxes,
    Multiselect,
    draggable,
  },
  data() {
    return {
      title: "Account Setup",
      editable: true,
      isDragging: false,
      //start terms variables
      is_terms_data_loading: true,
      termsTable: {
        table: {
          tableData: [],
        },
        isEdit: false,
        editRow: "",
        totalRows: 1,
      },
      openNewTermsForm: false,
      viewTermsFilter: false,
      termFilter: { policy_type: "" },
      //end terms variables

      //start booking source variables
      openPaymentPolicyForm: false,
      bookingSource: {
        name: "",
        image: null,
        edit: false,
        id: null,
        index: null,
        title: "Add Booking Source",
      },
      isMacrotechConnected: false,
      bookingSources: [],
      bookingSourceFormSubmitted: false,
      bookingSourceError: "",
      selectedBookingSource: null,
      paymentGateway: null,
      payment_gateways,
      submitted: false,
      paymentGatewayObj: {
        payment_gateway_type: "macrotech",
        macrotech_tcai: "",
        macrotech_tcac: "",
        macrotech_omi: "",
        macrotech_omt: "",
        macrotech_emi: "",
        macrotech_emdi: "",
        stripe_access_token: "",
        stripe_refresh_token: "",
        stripe_publishable_key: "",
        stripe_user_id: "",
        stripe_token_type: "",
        stripe_scope: "",
        stripe_livemode: "",
        stripe_dashboard_name: "",
        stripe_account: "",
        is_active: false,
      },
      bookingSourceNameList: [],
      //end booking source variables

      //start custom questions variables
      isShowCustomQuestion: false,
      //end custom questions variables

      //start guest experience variables
      guestExperiences: [],
      openGuestExperienceImageModal: false,
      guestExperienceImage: "",
      openGuestExperienceForm: false,
      bookingSourceFormSubmittedError: false,
      guestExperience: null,
      errorMessage: null,
      guestExperienceOptions: [],
      tempGuestExp: [],
      //end guest experience variables

      // custom question
      customQuestions: [],
      selectedQuestion: null,
      questionEdit: false,
      questionIndex: null,
      questionTitle: "",
      questionSubtitle: "",

      // PMS related variables
      isPmsConnected: false,
      pmsData: {
        login_url: "",
        customer_code: "",
        user_name: "",
        password: "",
        is_active: true,
      },
      selectedPms: "",
      isPmsBtnLoading: false,
      pmdFormSubmitted: false,

      hotel_fields: {},

      is_btn_loading: false,
    };
  },
  computed: {
    ...authComputed,
    dragOptions() {
      return {
        animation: 0,
        group: "description",
        disabled: !this.editable,
        ghostClass: "ghost",
      };
    },
    termsRows() {
      return this.termsTable.tableData.length;
    },
    paymentPolicyProps() {
      return {
        selectedBookingSource: this.selectedBookingSource,
        hotelCheckinTime: moment(this.hotel.check_in_time, "HH:mm:ss").format(
          "LT"
        ),
        hotelId: this.hotel.id,
      };
    },
    termsProps() {
      return {
        bookingSources: this.bookingSources,
        editData: this.termsTable.editRow,
        edit: this.termsTable.isEdit,
      };
    },
    questionProps() {
      return {
        bookingSources: this.bookingSources,
        selectedQuestion: this.selectedQuestion,
        questionEdit: this.questionEdit,
        questionIndex: this.questionIndex,
      };
    },
    taxesProps() {
      return {};
    },
  },
  mounted() {
    this.getBookingSources();
    this.getPaymentGatewayList();
    // this.getStripePaymentDetails();
    this.getGuestExperience();
    this.getCustomQuestions();
    this.getHotel();
    this.getPMSConnection();
  },
  methods: {
    ...authMethods,
    //start payment gateway functions
    connectStripe() {
      // window.location.href =
      //   "https://connect.stripe.com/oauth/authorize?response_type=code&client_id=ca_KU5xoWPEGSPD9sZvxvj20I0yDTbKR2Lo&scope=read_write";
    },
    async getStripePaymentDetails() {
      if (this.hotel.is_payment_gateway) {
        await UserService.getStripePaymentGatewayDetails()
          .then((payment_gateway) => {
            this.paymentGateway = payment_gateway;
          })
          .catch((error) => {
            errorHandler(error);
          });
      }
    },
    disconnectStripe() {
      // UserService.disconnectPaymentGateway(this.paymentGateway.id)
      //   .then(() => {
      //     Middleware.notification("Successfully Disconnected !!", "success");
      //     this.setHotel(this.hotel.id);
      //   })
      //   .catch((error) => {
      //     errorHandler(error);
      //   });
    },
    connectMacrotech() {
      this.isMacrotechConnected = true;
    },
    async getPaymentGatewayList() {
      if (this.hotel.is_payment_gateway) {
        await UserService.getPaymentGatewayList()
          .then((payment_gateway) => {
            this.paymentGatewayObj.payment_gateway_type =
              payment_gateway.payment_gateway_type;
            this.paymentGatewayObj.is_active = payment_gateway.is_active;
            this.paymentGatewayObj.macrotech_tcai =
              payment_gateway.macrotech_tcai;
            this.paymentGatewayObj.macrotech_tcac =
              payment_gateway.macrotech_tcac;
            this.paymentGatewayObj.macrotech_omi =
              payment_gateway.macrotech_omi;
            this.paymentGatewayObj.macrotech_omt =
              payment_gateway.macrotech_omt;
            this.paymentGatewayObj.macrotech_emi =
              payment_gateway.macrotech_emi;
            this.paymentGatewayObj.macrotech_emdi =
              payment_gateway.macrotech_emdi;
            this.paymentGatewayObj.stripe_access_token =
              payment_gateway.stripe_access_token;
            this.paymentGatewayObj.stripe_refresh_token =
              payment_gateway.stripe_refresh_token;
            this.paymentGatewayObj.stripe_publishable_key =
              payment_gateway.stripe_publishable_key;
            this.paymentGatewayObj.stripe_user_id =
              payment_gateway.stripe_user_id;
            this.paymentGatewayObj.stripe_token_type =
              payment_gateway.stripe_token_type;
            this.paymentGatewayObj.stripe_scope = payment_gateway.stripe_scope;
            this.paymentGatewayObj.stripe_livemode =
              payment_gateway.stripe_livemode;
            this.paymentGatewayObj.stripe_dashboard_name =
              payment_gateway.stripe_dashboard_name;
          })
          .catch((err) => {
            const response = errorHandler(err);
            if (response == 401) {
              this.getPaymentGatewayList();
            }
            if (err.response.status === 404) {
              this.paymentGatewayObj = initPaymentGatewayObj;
            }
          });
      }
    },
    submitPaymentGateway() {
      this.submitted = true;
      this.is_btn_loading = true;
      this.$v.$touch();
      if (this.$v.paymentGatewayObj.$invalid) {
        this.isBtnLoading = false;
        return;
      } else {
        let paymentGateway = new FormData();

        paymentGateway.append("hotel", this.hotel.id);
        paymentGateway.append(
          "payment_gateway_type",
          this.paymentGatewayObj.payment_gateway_type
        );
        paymentGateway.append(
          "macrotech_tcai",
          this.paymentGatewayObj.macrotech_tcai
        );
        paymentGateway.append(
          "macrotech_tcac",
          this.paymentGatewayObj.macrotech_tcac
        );
        paymentGateway.append(
          "macrotech_omi",
          this.paymentGatewayObj.macrotech_omi
        );
        paymentGateway.append(
          "macrotech_omt",
          this.paymentGatewayObj.macrotech_omt
        );
        paymentGateway.append(
          "macrotech_emi",
          this.paymentGatewayObj.macrotech_emi
        );
        paymentGateway.append(
          "macrotech_emdi",
          this.paymentGatewayObj.macrotech_emdi
        );
        UserService.connectPaymentGetway(paymentGateway)
          .then(
            (response) => {
              this.paymentGatewayObj = response;
              this.is_btn_loading = false;
              this.submitted = false;
              this.isMacrotechConnected = true;
              Middleware.notification("Successfully Updated !!", "success");
            },
            (error) => {
              errorHandler(error);
              this.is_btn_loading = false;
              this.hasError = true;
              if (error.response.data.non_field_errors[0]) {
                this.errorMsg = error.response.data.non_field_errors[0];
              }
            }
          )
          .catch((error) => {
            errorHandler(error);
            if (error.response.status == 404) {
              this.paymentGatewayObj = {};
            }
          });
      }
    },
    disconnectMacrotech() {
      console.log("disconnect macrotech");
    },
    //end payment gateway functions

    // start PMS related function
    async getPMSConnection() {
      if (this.hotel.is_pms_connection) {
        try {
          const response = await UserService.getConnectedPMS();
          if (response !== null || response !== undefined) {
            this.isPmsConnected = true;
            this.pmsData = response;
            this.selectedPms = response.pms_type;
          }
        } catch (error) {
          if (error.response.status !== 404) {
            errorHandler(error);
          } else {
            this.isPmsConnected = false;
          }
        }
      } else {
        this.isPmsConnected = this.hotel.is_pms_connection;
      }
    },

    // Select new PMS connection
    selectPms() {
      const displayPMS =
        this.selectedPms == "macrotech_pms"
          ? "Macrotech PMS"
          : this.selectedPms == "choice_advantage_pms"
          ? "Choice Advantage PMS"
          : this.selectedPms == "jonas_chorum_pms"
          ? "Jonas Chorum PMS"
          : "-";
      Swal.fire({
        title: "Are you sure?",
        text: `Your select PMS is : ${displayPMS}`,
        icon: "info",
        showCancelButton: true,
        confirmButtonColor: "#238dfa",
        cancelButtonColor: "#f46a6a",
        confirmButtonText: "Yes, I'm sure",
      }).then((result) => {
        if (result.value) {
          this.$bvModal.show("pms-modal");
          Middleware.notification(
            `Your Selected PMS is ${displayPMS}, Once you save changes you can't update from here !!`,
            "info"
          );
        }
      });
    },
    // Handle PMS ok event
    handlePmsOk(bvModalEvt) {
      bvModalEvt.preventDefault();
      this.handlePmsSubmit();
    },
    // Method is use for add new booking source
    handlePmsSubmit() {
      this.pmdFormSubmitted = true;
      this.isPmsBtnLoading = true;
      this.$v.$touch();
      if (this.$v.pmsData.$invalid) {
        this.isPmsBtnLoading = false;
        return;
      } else {
        Swal.fire({
          title: "Are you sure?",
          text: `Your want to use this PMS?`,
          icon: "info",
          showCancelButton: true,
          confirmButtonColor: "#238dfa",
          cancelButtonColor: "#f46a6a",
          confirmButtonText: "Yes, Confirm",
        }).then((result) => {
          if (result.value) {
            let pmsFormData = new FormData();
            pmsFormData.append("hotel", this.hotel.id);
            pmsFormData.append("pms_type", this.selectedPms);
            Object.keys(this.pmsData).map((key) => {
              pmsFormData.append(key, this.pmsData[key]);
            });
            UserService.AddPMS(pmsFormData).then(
              (response) => {
                this.pmsData = { ...this.pmsData, response };
                this.selectedPms = response.pms_type;
                this.isPmsConnected = true;
                this.pmdFormSubmitted = false;
                this.isPmsBtnLoading = false;
                this.resetPmsModal();
                Middleware.notification("Successfully added !!", "success");
              },
              (error) => {
                errorHandler(error);
                this.isPmsBtnLoading = false;
                this.selectedPms = "";
                this.isPmsConnected = false;
              }
            );
          }
        });
      }
    },
    resetPmsModal() {
      this.$bvModal.hide("pms-modal");
      this.pmsData = "";
      this.pmdFormSubmitted = false;
      this.isPmsBtnLoading = false;
    },
    //start booking source functions
    async getBookingSources() {
      await UserService.getBookingSourceList()
        .then((sources) => {
          this.bookingSources = sources;
          let arr = [];
          sources.map((item) => {
            this.bookingSourceNameList.push(item.name.toLowerCase());
            arr.push({ id: item.id, name: item.name });
          });
          this.guestExperienceOptions = arr;
        })
        .catch((error) => {
          errorHandler(error);
        });
    },
    handleOk(bvModalEvt) {
      bvModalEvt.preventDefault();
      this.handleSubmit();
    },
    // Method is use for add new booking source
    handleSubmit() {
      this.bookingSourceNameList = [...new Set(this.bookingSourceNameList)];
      this.bookingSourceFormSubmitted = true;
      this.bookingSourceFormSubmittedError = false;
      this.$v.$touch();
      if (this.$v.bookingSource.$invalid) {
        return;
      } else {
        if (this.bookingSource.edit) {
          this.bookingSourceNameList = this.bookingSourceNameList.filter(
            (item) => item !== this.bookingSource.name.toLowerCase().trim()
          );
        }
        if (
          this.bookingSourceNameList.includes(
            this.bookingSource.name.toLowerCase().trim()
          )
        ) {
          this.bookingSourceFormSubmittedError = true;
          this.bookingSourceError = "Name must be unique.";
        } else {
          this.bookingSourceError = "";
        }
        if (!this.bookingSourceFormSubmittedError) {
          if (this.bookingSource.edit) {
            let bookingSourceData = new FormData();
            bookingSourceData.append("name", this.bookingSource.name);
            hotelService
              .editBookingSource(bookingSourceData, this.bookingSource.id)
              .then((bookingSource) => {
                this.bookingSources[this.bookingSource.index] = bookingSource;
                this.bookingSourceFormSubmitted = false;
                this.bookingSourceFormSubmittedError = false;
                this.$bvModal.hide("source-modal");
                Middleware.notification("Successfully updated !!", "success");
              })
              .catch((error) => {
                errorHandler(error);
                this.bookingSourceFormSubmittedError = true;
                this.bookingSourceError = error.response.data;
              });
          } else {
            let bookingSourceData = new FormData();
            bookingSourceData.append("hotel", this.hotel.id);
            bookingSourceData.append("name", this.bookingSource.name);
            if (this.bookingSource.image != null) {
              bookingSourceData.append("image", this.bookingSource.image);
            }
            hotelService
              .createBookingSource(bookingSourceData)
              .then((bookingSource) => {
                this.bookingSources.push(bookingSource);
                this.guestExperienceOptions.push(bookingSource);
                this.bookingSourceFormSubmitted = false;
                this.bookingSourceFormSubmittedError = false;
                this.$bvModal.hide("source-modal");
                Middleware.notification("Successfully added !!", "success");
              })
              .catch((error) => {
                errorHandler(error);
                this.bookingSourceFormSubmittedError = true;
                this.bookingSourceError = error.response.data;
              });
          }
        }
      }
    },
    resetModal() {
      this.bookingSource.name = null;
      this.bookingSource.image = null;
      this.bookingSource.edit = false;
      this.bookingSource.id = null;
      this.bookingSource.index = null;
      this.bookingSource.title = "Add Booking Source";
      this.bookingSourceFormSubmitted = false;
      this.bookingSourceFormSubmittedError = false;
      this.bookingSourceError = null;
    },
    editSourceModal(source, index) {
      this.bookingSource.id = source.id;
      this.bookingSource.index = index;
      this.bookingSource.name = source.name;
      this.bookingSource.image = null;
      this.bookingSource.edit = true;
      this.bookingSource.title = "Edit Booking Source";
      this.$bvModal.show("source-modal");
    },
    deletePaymentPolicy(sourceId) {
      Swal.fire({
        title: "Are you sure?",
        text: "You won't be able to revert this!",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#238dfa",
        cancelButtonColor: "#f46a6a",
        confirmButtonText: "Yes, delete it!",
      }).then((result) => {
        if (result.value) {
          hotelService
            .deleteBookingSource(sourceId)
            .then(() => {
              let index = this.bookingSources.findIndex(
                (el) => el.id === sourceId
              );
              this.bookingSources.splice(index, 1);
              let indexOfGuest = this.guestExperienceOptions.findIndex(
                (el) => el.id === sourceId
              );
              this.guestExperienceOptions.splice(indexOfGuest, 1);
              Middleware.notification("Successfully deleted !!", "danger");

              this.termsTable.isLoading = false;
            })
            .catch((error) => {
              errorHandler(error);
            });
        }
      });
    },
    newPaymentPolicyForm(booking_source_id) {
      this.selectedBookingSource = booking_source_id;
      this.openPaymentPolicyForm = !this.openPaymentPolicyForm;
    },
    policyChanged() {
      Middleware.notification("Successfully updated !!", "success");

      this.getBookingSources();
      this.newPaymentPolicyForm();
    },
    changePolicyStatus(policy_name, source_id, index) {
      let bookingSourceData = new FormData();
      bookingSourceData.append(policy_name, false);

      UserService.editBookingSource(bookingSourceData, source_id).then(
        () => {
          this.getBookingSources();
          Middleware.notification("Successfully changed !!", "success");

          // this.bookingSources[index] = bookingSource;
        },
        (error) => {
          errorHandler(error);
        }
      );
    },
    //end booking source functions

    //start guest experience function
    async getGuestExperience() {
      await UserService.getGuestExperienceList()
        .then((guestExperiences) => {
          this.guestExperiences = guestExperiences;
        })
        .catch((error) => {
          errorHandler(error);
        });
    },
    editGuestExperience(data) {
      let id = "";
      let object = {};
      let ids = [];
      // Condition for active and de-active guest experience
      if (data.identity === "switch") {
        id = data.id;
        const isActive = (data.is_active = !data.is_active);
        object = { is_active: isActive };
      }
      // Condition for add new booking source into guest experience
      else if (data.identity === "addNew") {
        id = data.id;
        if (data.booking_source.length === 0) {
          this.guestExperience.booking_source = [];
          object = { booking_source: [] };
        } else {
          this.guestExperience.booking_source = [...this.tempGuestExp];
          data.booking_source.map((item) => {
            ids.push(item.id);
            object = { booking_source: ids };
          });
        }
      }
      // Condition for remove booking source from guest experience
      else {
        id = data.id.id;
        data.id.booking_source.map((item) => {
          ids.push(item.id);
          if (item.id === data.bookingSourceId) {
            ids.splice(ids.indexOf(item.id), 1);
          }
          object = { booking_source: ids };
        });
      }
      // Api call to update booking source
      UserService.editGuestExperience(object, id)
        .then(() => {
          this.openGuestExperienceForm = false;
          Middleware.notification("Successfully updated !!", "success");
        })
        .catch((err) => {
          errorHandler(err);
          this.errorMessage = err.response.data
            ? err.response.data
            : err.message;
          this.$toast.error(err?.message);
        });
    },
    openModelForGuestExperienceImage(data) {
      this.guestExperienceImage = data;
      this.openGuestExperienceImageModal = true;
    },
    openModelForGuestExperience(data) {
      this.openGuestExperienceForm = true;
      this.guestExperience = data;
      this.tempGuestExp = this.guestExperience.booking_source;
      this.errorMessage = null;
    },
    hiddenData() {
      this.getGuestExperience();
    },
    attachAll() {
      this.tempGuestExp = [...this.guestExperienceOptions];
    },
    //end guest experience function

    //start terms functions
    newTermsForm() {
      if (this.openNewTermsForm == true) {
        this.termsTable.editRow = null;
        this.termsTable.isEdit = false;
      }
      this.openNewTermsForm = !this.openNewTermsForm;
    },
    async getTerms(filter = "") {
      await UserService.getTermsList(filter)
        .then((terms) => {
          this.termsTable.table.tableData = terms;
          this.is_terms_data_loading = false;
        })
        .catch((err) => {
          errorHandler(err);
        });
    },
    termCreated(data) {
      if (data.by === "edit") {
        this.termsTable.table.tableData = this.termsTable.table.tableData.map(
          (item) => {
            if (item.id === data.terms.id) {
              item = data.terms;
            }
            return item;
          }
        );
        Middleware.notification("Successfully updated !!", "success");

        this.newTermsForm();
      } else {
        this.termsTable.table.tableData.push(data);
        Middleware.notification("Successfully created !!", "success");

        this.newTermsForm();
      }
    },
    saveAndAddNewTerms(data) {
      this.termsTable.table.tableData.push(data);
      Middleware.notification("Successfully created !!", "success");
    },
    changeTermsStatus(data) {
      UserService.editTerms(
        {
          is_publish: data.is_publish,
        },
        data.id
      ).then(
        () => {
          Middleware.notification("Successfully changed !!", "success");
        },
        (error) => {
          errorHandler(error);
        }
      );
    },
    deleteTerms(id) {
      Swal.fire({
        title: "Are you sure?",
        text: "You won't be able to revert this!",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#238dfa",
        cancelButtonColor: "#f46a6a",
        confirmButtonText: "Yes, delete it!",
      }).then((result) => {
        if (result.value) {
          UserService.deleteTerms(id).then(
            () => {
              let index = this.termsTable.table.tableData.findIndex(
                (el) => el.id === id
              );
              this.termsTable.table.tableData.splice(index, 1);
              Middleware.notification("Successfully deleted !!", "danger");

              this.termsTable.isLoading = false;
            },
            (error) => {
              errorHandler(error);
            }
          );
        }
      });
    },
    editTerms(row) {
      this.termsTable.editRow = row;
      this.termsTable.isEdit = true;
      this.newTermsForm();
    },
    async openTermsFilter() {
      this.viewTermsFilter = !this.viewTermsFilter;
    },
    filterTermsData() {
      let filter = "";
      if (this.termFilter.policy_type == "all") {
        filter = "";
        this.getTerms(filter);
      } else {
        filter = "?policy_type=" + this.termFilter.policy_type;
        this.getTerms(filter);
      }
      this.openTermsFilter();
      this.termFilter.policy_type = "";
    },
    //end terms functions

    //start custom questions function
    async getCustomQuestions() {
      await UserService.getCustomQuestionList()
        .then((customQuestion) => {
          this.customQuestions = customQuestion;
        })
        .catch((error) => {
          errorHandler(error);
        });
    },
    async deleteCustomQuestion(question_id, index) {
      Swal.fire({
        title: "Are you sure?",
        text: "You won't be able to revert this!",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#238dfa",
        cancelButtonColor: "#f46a6a",
        confirmButtonText: "Yes, delete it!",
      }).then((result) => {
        if (result.value) {
          UserService.deleteCustomQuestion(question_id).then(
            () => {
              Middleware.notification("Successfully deleted !!", "danger");

              this.isLoading = false;
              this.customQuestions.splice(index, 1);
            },
            (error) => {
              errorHandler(error);
            }
          );
        }
      });
    },
    editCustomQuestion(question, index) {
      this.selectedQuestion = question;
      this.questionEdit = true;
      this.questionIndex = index;
      this.customQuestionDrawer();
    },
    customQuestionDrawer() {
      if (this.isShowCustomQuestion == true) {
        this.selectedQuestion = null;
        this.questionEdit = false;
        this.questionIndex = null;
      }
      this.isShowCustomQuestion = !this.isShowCustomQuestion;
    },
    questionAdded(question, questionEdit, index) {
      if (questionEdit) {
        this.customQuestions[index] = question;
        Middleware.notification("Successfully updated !!", "success");
      } else {
        this.customQuestions.push(question);
        Middleware.notification("Successfully added !!", "success");
      }
      this.customQuestionDrawer();
    },
    saveAndAddNewCustomQuestions(question) {
      this.customQuestions.push(question);
      Middleware.notification("Successfully added !!", "success");
    },
    onChoose: function (evt) {
      const questionData = new FormData();
      questionData.append("priority_order", evt.moved.newIndex + 1);
      UserService.updateCustomQuestion(questionData, evt.moved.element.id)
        .then(() => {
          Middleware.notification("Question positions changed !!", "success");
        })
        .catch((error) => {
          errorHandler(error);
        });
    },
    getHotel() {
      this.hotel_fields.custom_question_title =
        this.hotel.custom_question_title;
      this.hotel_fields.custom_question_sub_title =
        this.hotel.custom_question_sub_title;
    },
    updateTitle() {
      let hotelData = new FormData();
      hotelData.append(
        "custom_question_title",
        this.hotel.custom_question_title
      );
      hotelData.append(
        "custom_question_sub_title",
        this.hotel.custom_question_sub_title
      );

      hotelService.updateHotelDetails(hotelData).then(
        () => {
          this.setHotel(this.hotel.id).then(() => {
            this.getHotel();
            Middleware.notification("Successfully updated !!", "success");
          });
        },
        (error) => {
          errorHandler(error);
        }
      );
    },
    //end custom questions function
  },
  // Validation
  validations: {
    pmsData: {
      login_url: { required },
      customer_code: { required },
      user_name: { required },
      password: { required },
    },
    bookingSource: {
      name: {
        required,
      },
    },
    paymentGatewayObj: {
      macrotech_tcai: {
        required,
      },
      macrotech_tcac: {
        required,
      },
      macrotech_omi: {
        required,
      },
      macrotech_omt: {
        required,
      },
      macrotech_emi: {
        required,
      },
      macrotech_emdi: {
        required,
      },
    },
  },
};
</script>

<template>
  <div>
    <PageHeader :title="title" />
    <div class="row">
      <div class="col-lg-12">
        <div role="tablist">
          <!--Start payment gateway section -->
          <b-card no-body class="mb-3">
            <b-card-header
              header-tag="header"
              role="tab"
              v-b-toggle.paymentGateway
              class="cursor"
            >
              <h6 class="my-1">
                <a class="text-dark" href="javascript: void(0);"
                  >Payment Gateway</a
                >
              </h6>
            </b-card-header>

            <b-collapse id="paymentGateway" visible accordion="my-accordion">
              <b-card-body>
                <b-card-text>
                  <div class="row">
                    <div class="col-md-12">
                      <div class="row">
                        <div class="col-md-12">
                          <h3 class="mt-2 text-center">
                            Connect to your Payment Gateway
                          </h3>
                        </div>
                      </div>
                      <div class="row mt-4">
                        <div class="col-md-6">
                          <!-- Connect strip -->
                          <div class="row">
                            <div class="col-md-12">
                              <b-form-group
                                class="mb-3 form-label"
                                label="Payment Type"
                                label-for="payment_type"
                              >
                                <b-form-select
                                  class="form-select"
                                  id="payment_type"
                                  type="text"
                                  autocomplete="off"
                                  :options="payment_gateways"
                                  v-model="
                                    paymentGatewayObj.payment_gateway_type
                                  "
                                  :disabled="paymentGatewayObj.is_active"
                                >
                                </b-form-select>
                              </b-form-group>
                            </div>
                          </div>
                          <!-- Connect macrotech-->
                          <div
                            class="row mb-3"
                            v-if="
                              paymentGatewayObj.payment_gateway_type ==
                                'macrotech' &&
                              !paymentGatewayObj.is_active &&
                              !isMacrotechConnected
                            "
                          >
                            <div class="col-12">
                              <b-form-group
                                class="mb-3"
                                label="Transaction Cloud Account Id"
                              >
                                <template slot="label">
                                  Transaction Cloud Account Id
                                  <span class="text-danger">*</span>
                                </template>
                                <b-form-input
                                  v-model="paymentGatewayObj.macrotech_tcai"
                                  type="text"
                                  autocomplete="off"
                                  :class="{
                                    'is-invalid':
                                      submitted &&
                                      $v.paymentGatewayObj.macrotech_tcai
                                        .$error,
                                  }"
                                  name="macrotech_tcai"
                                  id="macrotech_tcai"
                                ></b-form-input>
                              </b-form-group>
                              <div
                                v-if="
                                  submitted &&
                                  $v.paymentGatewayObj.macrotech_tcai.$error
                                "
                                class="invalid-feedback"
                              >
                                <span
                                  v-if="
                                    !$v.paymentGatewayObj.macrotech_tcai
                                      .required
                                  "
                                  >Transaction Cloud Account Id is
                                  required.</span
                                >
                              </div>
                            </div>

                            <div class="col-12">
                              <b-form-group
                                class="mb-3"
                                label="Transaction Cloud Auth Code"
                              >
                                <template slot="label">
                                  Transaction Cloud Auth Code
                                  <span class="text-danger">*</span>
                                </template>
                                <b-form-input
                                  v-model="paymentGatewayObj.macrotech_tcac"
                                  type="text"
                                  autocomplete="off"
                                  :class="{
                                    'is-invalid':
                                      submitted &&
                                      $v.paymentGatewayObj.macrotech_tcac
                                        .$error,
                                  }"
                                  name="macrotech_tcac"
                                  id="macrotech_tcac"
                                ></b-form-input>
                              </b-form-group>
                              <div
                                v-if="
                                  submitted &&
                                  $v.paymentGatewayObj.macrotech_tcac.$error
                                "
                                class="invalid-feedback"
                              >
                                <span
                                  v-if="
                                    !$v.paymentGatewayObj.macrotech_tcac
                                      .required
                                  "
                                  >Transaction Cloud Auth Code is
                                  required.</span
                                >
                              </div>
                            </div>

                            <div class="col-12">
                              <b-form-group
                                class="mb-3"
                                label="Online Merchant Id"
                              >
                                <template slot="label">
                                  Online Merchant Id
                                  <span class="text-danger">*</span>
                                </template>
                                <b-form-input
                                  v-model="paymentGatewayObj.macrotech_omt"
                                  type="text"
                                  autocomplete="off"
                                  :class="{
                                    'is-invalid':
                                      submitted &&
                                      $v.paymentGatewayObj.macrotech_omt.$error,
                                  }"
                                  name="macrotech_omt"
                                  id="macrotech_omt"
                                ></b-form-input>
                              </b-form-group>
                              <div
                                v-if="
                                  submitted &&
                                  $v.paymentGatewayObj.macrotech_omt.$error
                                "
                                class="invalid-feedback"
                              >
                                <span
                                  v-if="
                                    !$v.paymentGatewayObj.macrotech_omt.required
                                  "
                                  >Online Merchant Id is required.</span
                                >
                              </div>
                            </div>

                            <div class="col-12">
                              <b-form-group
                                class="mb-3"
                                label="Online Merchant Token"
                              >
                                <template slot="label">
                                  Online Merchant Token
                                  <span class="text-danger">*</span>
                                </template>
                                <b-form-input
                                  v-model="paymentGatewayObj.macrotech_omi"
                                  type="text"
                                  autocomplete="off"
                                  :class="{
                                    'is-invalid':
                                      submitted &&
                                      $v.paymentGatewayObj.macrotech_omi.$error,
                                  }"
                                  name="macrotech_omi"
                                  id="macrotech_omi"
                                ></b-form-input>
                              </b-form-group>
                              <div
                                v-if="
                                  submitted &&
                                  $v.paymentGatewayObj.macrotech_omi.$error
                                "
                                class="invalid-feedback"
                              >
                                <span
                                  v-if="
                                    !$v.paymentGatewayObj.macrotech_omi.required
                                  "
                                  >Online Merchant Token is required.</span
                                >
                              </div>
                            </div>

                            <div class="col-12">
                              <b-form-group
                                class="mb-3"
                                label="EMV Merchant Id"
                              >
                                <template slot="label">
                                  EMV Merchant Id
                                  <span class="text-danger">*</span>
                                </template>
                                <b-form-input
                                  v-model="paymentGatewayObj.macrotech_emi"
                                  type="text"
                                  autocomplete="off"
                                  :class="{
                                    'is-invalid':
                                      submitted &&
                                      $v.paymentGatewayObj.macrotech_emi.$error,
                                  }"
                                  name="macrotech_emi"
                                  id="macrotech_emi"
                                ></b-form-input>
                              </b-form-group>
                              <div
                                v-if="
                                  submitted &&
                                  $v.paymentGatewayObj.macrotech_emi.$error
                                "
                                class="invalid-feedback"
                              >
                                <span
                                  v-if="
                                    !$v.paymentGatewayObj.macrotech_emi.required
                                  "
                                  >EMV Merchant Id is required.</span
                                >
                              </div>
                            </div>

                            <div class="col-12">
                              <b-form-group
                                class="mb-3"
                                label="EMV Merchant Device Id"
                              >
                                <template slot="label">
                                  EMV Merchant Device Id
                                  <span class="text-danger">*</span>
                                </template>
                                <b-form-input
                                  v-model="paymentGatewayObj.macrotech_emdi"
                                  type="text"
                                  autocomplete="off"
                                  :class="{
                                    'is-invalid':
                                      submitted &&
                                      $v.paymentGatewayObj.macrotech_emdi
                                        .$error,
                                  }"
                                  name="macrotech_emdi"
                                  id="macrotech_emdi"
                                ></b-form-input>
                              </b-form-group>
                              <div
                                v-if="
                                  submitted &&
                                  $v.paymentGatewayObj.macrotech_emdi.$error
                                "
                                class="invalid-feedback"
                              >
                                <span
                                  v-if="
                                    !$v.paymentGatewayObj.macrotech_emdi
                                      .required
                                  "
                                  >EMV Merchant Device Id is required.</span
                                >
                              </div>
                            </div>

                            <div class="col-12">
                              <button
                                class="btn btn-primary me-2"
                                :class="{ disabled: is_btn_loading }"
                                @click="submitPaymentGateway"
                              >
                                <i
                                  v-if="is_btn_loading"
                                  class="bx bx-loader bx-spin font-size-16 align-middle me-2"
                                ></i
                                >Save
                              </button>
                            </div>
                          </div>
                          <!--Start Strip connection section -->
                          <div
                            class="row"
                            v-if="
                              paymentGatewayObj.payment_gateway_type == 'stripe'
                            "
                          >
                            <div class="col-md-12">
                              <img
                                src="https://app.chargeautomation.com/storage/uploads/payment_gateway_logos/stripe.png"
                                width="100"
                                class="img-responsive my-2"
                              />
                              <img
                                src="https://app.chargeautomation.com/images/done.gif"
                                class="payment-done-icon ml-2"
                                style="width: 35px"
                                v-if="paymentGatewayObj.is_active"
                              />

                              <div class="row">
                                <div class="col-md-12">
                                  <button
                                    v-if="!paymentGatewayObj.is_active"
                                    class="btn btn-primary rounded-pill waves-effect waves-light"
                                    :class="{
                                      disabled: paymentGatewayObj.is_active,
                                    }"
                                    @click="connectStripe"
                                  >
                                    Connect
                                  </button>
                                  <button
                                    :disabled="
                                      paymentGatewayObj.is_active == true
                                    "
                                    v-else
                                    class="btn btn-primary rounded-pill waves-effect waves-light"
                                    :class="{
                                      disabled: !paymentGatewayObj.is_active,
                                    }"
                                    @click="disconnectStripe"
                                  >
                                    Disconnect
                                  </button>
                                </div>
                              </div>

                              <div
                                class="row mt-2"
                                v-if="this.paymentGatewayObj.is_active"
                              >
                                <div class="col-md-5">
                                  Stripe Account: <b>{{ this.hotel.name }}</b>
                                </div>
                              </div>
                              <hr />

                              <div class="mb-1 mt-3">
                                <p>
                                  <i
                                    class="fas fa-shield-alt text-primary me-2"
                                  ></i>
                                  <b>Charge back Protection Included for</b>
                                  <span
                                    class="badge badge-soft-primary ms-2 me-2"
                                    >Free</span
                                  >
                                  <a
                                    href="javascript: void(0)"
                                    v-b-popover.hover="
                                      'Protect your payments from fraud Learn More'
                                    "
                                  >
                                    <i
                                      class="fa fa-info-circle fa-xs text-muted ml-1"
                                      data-bs-container="#tooltip-container"
                                      tabindex="0"
                                      data-plugin="tippy"
                                      data-tippy-arrow="true"
                                      data-tippy-animation="fade"
                                      data-tippy=""
                                      data-original-title="Protect your payments from fraud Learn More"
                                    ></i>
                                  </a>
                                </p>
                              </div>
                            </div>
                          </div>
                          <!-- End -->
                          <!-- Start macrotech connection section -->
                          <div
                            class="row"
                            v-if="
                              paymentGatewayObj.payment_gateway_type ==
                                'macrotech' && paymentGatewayObj.is_active
                            "
                          >
                            <div class="col-md-12">
                              <div class="d-flex align-items-center">
                                <h1 style="color: #6673e3" class="my-2">
                                  Macrotech
                                </h1>
                                <img
                                  src="https://app.chargeautomation.com/images/done.gif"
                                  class="payment-done-icon ml-2 header-picture-img"
                                  v-if="paymentGatewayObj.is_active"
                                />
                              </div>

                              <div class="row">
                                <div class="col-md-12">
                                  <button
                                    v-if="!paymentGatewayObj.is_active"
                                    class="btn btn-primary rounded-pill waves-effect waves-light"
                                    :class="{
                                      disabled: paymentGatewayObj.is_active,
                                    }"
                                    @click="connectMacrotech"
                                  >
                                    Connect
                                  </button>
                                  <button
                                    :disabled="
                                      paymentGatewayObj.is_active == true
                                    "
                                    v-else
                                    class="btn btn-primary rounded-pill waves-effect waves-light"
                                    :class="{
                                      disabled: !paymentGatewayObj.is_active,
                                    }"
                                    @click="disconnectMacrotech"
                                  >
                                    Disconnect
                                  </button>
                                </div>
                              </div>

                              <div
                                class="row mt-2"
                                v-if="paymentGatewayObj.is_active"
                              >
                                <div class="col-md-12 d-flex">
                                  Macrotech Merchant Id :
                                  <b class="ms-1">{{
                                    paymentGatewayObj.macrotech_tcai
                                  }}</b>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div class="col-md-6">
                          <div class="alert alert-secondary" role="alert">
                            <h5>What can I do by connecting?</h5>
                            <p class="mb-0">
                              You can schedule, create and send payment request
                              with one click.
                            </p>
                          </div>
                          <div class="alert alert-secondary" role="alert">
                            <h5>Does Macrotech collect my funds?</h5>
                            <p class="mb-0">
                              No, Macrotech uses your connected payment gateway,
                              so you are in control of your funds at all time.
                            </p>
                          </div>
                          <div class="alert alert-secondary" role="alert">
                            <h5>How secure it is?</h5>
                            <p class="mb-0">
                              We are PCI compliance and we do not store credit
                              card data.
                            </p>
                          </div>
                          <p>
                            <b>Question?</b> Feel free to
                            <a href="javascript: void(0);"
                              >speak with an expert</a
                            >
                            or visit our
                            <a href="javascript: void(0);">FAQ</a>
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                </b-card-text>
              </b-card-body>
            </b-collapse>
          </b-card>
          <!--End payment gateway section -->

          <!--Start PMS connection section -->
          <b-card no-body class="mb-3">
            <b-card-header
              header-tag="header"
              role="tab"
              v-b-toggle.pmsConnection
              class="cursor"
            >
              <h6 class="my-1">
                <a class="text-dark" href="javascript: void(0);"
                  >PMS Connection</a
                >
              </h6>
            </b-card-header>
            <b-collapse id="pmsConnection" visible accordion="my-accordion">
              <b-card-body>
                <b-card-text>
                  <div class="row">
                    <div class="col-12 text-center">
                      <h3 class="mt-2">Connect to your PMS</h3>
                    </div>
                  </div>
                  <div class="row mt-4">
                    <div class="col-md-6">
                      <div class="row">
                        <div class="col-md-12">
                          <label for="">Select Your PMS System</label>
                          <select
                            name="no_pms"
                            id="no_pms"
                            class="form-select"
                            v-model="selectedPms"
                            :disabled="isPmsConnected"
                            @change="selectPms"
                          >
                            <option value="macrotech_pms">Macrotech PMS</option>
                            <option value="choice_advantage_pms">
                              Choice Advantage PMS
                            </option>
                            <option value="jonas_chorum_pms">
                              Jonas Chorum PMS
                            </option>
                          </select>
                          <br />
                        </div>
                      </div>
                      <div class="row">
                        <div class="col-md-12">
                          <div
                            v-if="isPmsConnected"
                            class="form-check mb-2 form-check-info custome-form-check"
                          >
                            <label class="form-check-label" for="pms_is_connect"
                              >Connected:
                              {{
                                pmsData.pms_type == "macrotech_pms"
                                  ? "Macrotech PMS"
                                  : pmsData.pms_type == "choice_advantage_pms"
                                  ? "Choice Advantage PMS"
                                  : pmsData.pms_type == "jonas_chorum_pms"
                                  ? "Jonas Chorum PMS"
                                  : "-"
                              }}</label
                            >
                            <input
                              class="form-check-input custome-form-check-input rounded-circle custome-form-input"
                              type="checkbox"
                              name="pms_is_connect"
                              value=""
                              checked
                              id="pms_is_connect"
                            />
                            <label class="ms-3"
                              >Customer Code :
                              {{ pmsData.customer_code }}</label
                            >
                            <label class="ms-3"
                              >User Name : {{ pmsData.user_name }}</label
                            >
                            <label>Login URL : {{ pmsData.login_url }}</label>
                          </div>
                        </div>
                      </div>
                      <div class="alert alert-warning" role="alert">
                        <i class="mdi mdi-alert-outline me-2"></i>
                        <strong>Note:</strong> Once you select No PMS, you won't
                        be able to change PMS afterward.
                      </div>
                      <div class="alert alert-success" role="alert">
                        <i class="mdi mdi-check-all me-2"></i>
                        <strong>Note:</strong> By selecting No PMS, you will be
                        able to manually create rentals and bookings on
                        Macrotech.
                      </div>
                    </div>
                    <div class="col-md-6">
                      <div class="alert alert-secondary" role="alert">
                        <h5>What if my PMS/Channel Manager is not listed?</h5>
                        <p class="mb-0">
                          You can still use us by selecting 'No PMS' in the
                          dropdown
                        </p>
                      </div>
                      <div class="alert alert-secondary" role="alert">
                        <h5>
                          Will anything be sent to my guests upon connecting?
                        </h5>
                        <p class="mb-0">
                          No. Nothing will be turned on automatically when you
                          connect your account. You will be able to manually
                          turn on tools.
                        </p>
                      </div>
                      <div class="alert alert-secondary" role="alert">
                        <h5>Can I delete or disconnect data in the future?</h5>
                        <p class="mb-0">
                          Yes, Macrotech is GDPR ready allowing you to securely
                          control and delete data at any time.
                        </p>
                      </div>
                      <p>
                        <b>Question?</b> Feel free to
                        <a href="javascript: void(0);">speak with an expert</a>
                        or visit our
                        <a href="javascript: void(0);">FAQ</a>
                      </p>
                    </div>
                  </div>
                </b-card-text>
              </b-card-body>
            </b-collapse>
          </b-card>
          <!--End PMS connection section -->

          <!--Start payment policy section -->
          <b-card no-body class="mb-3">
            <b-card-header
              header-tag="header"
              role="tab"
              v-b-toggle.paymentPolicy
              class="cursor"
            >
              <h6 class="my-1">
                <a class="text-dark" href="javascript: void(0);"
                  >Payment Policy</a
                >
              </h6>
            </b-card-header>
            <b-collapse id="paymentPolicy" visible accordion="my-accordion">
              <b-card-body>
                <b-card-text>
                  <div class="row">
                    <div
                      class="col-xxl-3 col-xl-4 col-lg-6 col-md-6"
                      v-for="(source, index) in bookingSources"
                      :key="index"
                    >
                      <div class="card plan-box custom-card-height">
                        <div class="card-body">
                          <div class="text-truncate w-100">
                            <div
                              class="d-flex align-items-center justify-content-between"
                            >
                              <h5 class="text-truncate mb-0">
                                <span
                                  :id="String(index)"
                                  v-if="source.name != 'Direct'"
                                  v-b-popover.hover="'Edit Booking Source'"
                                  class="cursor"
                                  @click="editSourceModal(source, index)"
                                >
                                  {{ source.name }}
                                </span>
                                <span v-else>
                                  {{ source.name }}
                                </span>
                              </h5>
                              <div>
                                <i
                                  class="fas fa-pencil-alt text-success me-1 pencil-icon fs-5"
                                  v-b-popover.hover="'Update Auto Payment Rule'"
                                  @click="newPaymentPolicyForm(source.id)"
                                ></i>
                                <i
                                  v-if="index != 0"
                                  class="fas fa-trash ms-2 h5 text-primary"
                                  v-b-popover.hover="'Delete Payment Rule'"
                                  @click="deletePaymentPolicy(source.id)"
                                ></i>
                              </div>
                            </div>
                          </div>
                          <div class="plan-features mt-2" :id="String(index)">
                            <!-- For credit card validation -->
                            <p class="d-flex align-items-center">
                              <i
                                class="bx bx-checkbox-square me-2"
                                :class="[
                                  source.is_credit_card_validation
                                    ? 'text-primary'
                                    : 'text-secondary',
                                ]"
                              ></i>
                              <span
                                class="badge d-flex align-items-center py-1 px-2 card-badge"
                                :class="[
                                  source.is_credit_card_validation
                                    ? 'badge-soft-primary'
                                    : 'badge-soft-secondary',
                                ]"
                              >
                                <template
                                  v-if="source.is_credit_card_validation"
                                >
                                  Credit Card Validation
                                </template>
                                <del v-else> Credit Card Validation </del>
                                <i
                                  v-if="source.is_credit_card_validation"
                                  class="bx bx-x ms-2 cross-icon"
                                  @click="
                                    changePolicyStatus(
                                      'is_credit_card_validation',
                                      source.id,
                                      index
                                    )
                                  "
                                ></i>
                              </span>
                            </p>
                            <p class="d-flex align-items-center">
                              <i
                                class="bx bx-checkbox-square me-2"
                                :class="[
                                  source.is_reservation_payment
                                    ? 'text-primary'
                                    : 'text-secondary',
                                ]"
                              ></i>
                              <span
                                class="badge d-flex align-items-center py-1 px-2 card-badge"
                                :class="[
                                  source.is_reservation_payment
                                    ? 'badge-soft-primary'
                                    : 'badge-soft-secondary',
                                ]"
                              >
                                <template v-if="source.is_reservation_payment">
                                  Reservation Payment
                                </template>
                                <del v-else> Reservation Payment </del>
                                <i
                                  v-if="source.is_reservation_payment"
                                  class="bx bx-x ms-2 cross-icon"
                                  @click="
                                    changePolicyStatus(
                                      'is_reservation_payment',
                                      source.id,
                                      index
                                    )
                                  "
                                ></i>
                              </span>
                            </p>

                            <!-- For security deposit -->
                            <p class="d-flex align-items-center">
                              <i
                                class="bx bx-checkbox-square me-2"
                                :class="[
                                  source.is_security_deposit
                                    ? 'text-primary'
                                    : 'text-secondary',
                                ]"
                              ></i>
                              <span
                                class="badge d-flex align-items-center py-1 px-2 card-badge"
                                :class="[
                                  source.is_security_deposit
                                    ? 'badge-soft-primary'
                                    : 'badge-soft-secondary',
                                ]"
                              >
                                <template v-if="source.is_security_deposit">
                                  Security Deposit
                                </template>
                                <del v-else> Security Deposit </del>
                                <i
                                  v-if="source.is_security_deposit"
                                  class="bx bx-x ms-2 cross-icon"
                                  @click="
                                    changePolicyStatus(
                                      'is_security_deposit',
                                      source.id,
                                      index
                                    )
                                  "
                                ></i>
                              </span>
                            </p>

                            <!-- For cancellation policy -->
                            <p class="d-flex align-items-center">
                              <i
                                class="bx bx-checkbox-square me-2"
                                :class="[
                                  source.is_cancellation_policy
                                    ? 'text-primary'
                                    : 'text-secondary',
                                ]"
                              ></i>
                              <span
                                class="badge d-flex align-items-center py-1 px-2 card-badge"
                                :class="[
                                  source.is_cancellation_policy
                                    ? 'badge-soft-primary'
                                    : 'badge-soft-secondary',
                                ]"
                              >
                                <template v-if="source.is_cancellation_policy">
                                  Cancellation Policy
                                </template>
                                <del v-else> Cancellation Policy </del>
                                <i
                                  v-if="source.is_cancellation_policy"
                                  class="bx bx-x ms-2 cross-icon"
                                  @click="
                                    changePolicyStatus(
                                      'is_cancellation_policy',
                                      source.id,
                                      index
                                    )
                                  "
                                ></i>
                              </span>
                            </p>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="col-xl-3 col-md-6">
                      <div
                        class="card-dashed plan-box custom-card-height d-flex align-items-center justify-content-center"
                        v-b-modal.source-modal
                      >
                        <div class="card-body">
                          <a href="javascript: void(0);">
                            <div class="text-center">
                              <label for="" class="fs-5">Add New Source</label>
                            </div>
                            <i class="fas fa-plus fs-3 d-block text-center"></i>
                          </a>
                        </div>
                      </div>
                    </div>
                  </div>
                </b-card-text>
              </b-card-body>
            </b-collapse>
          </b-card>
          <!--End payment policy section -->

          <!--Start check-in policy section -->
          <b-card no-body class="mb-3">
            <b-card-header
              header-tag="header"
              role="tab"
              v-b-toggle.checkInPolicy
              class="cursor"
            >
              <h6 class="my-1">
                <a class="text-dark" href="javascript: void(0);"
                  >Check-in Policy</a
                >
              </h6>
            </b-card-header>
            <b-collapse
              id="checkInPolicy"
              visible
              accordion="my-accordion"
              role="tabpanel"
            >
              <b-card-body>
                <b-card-text>
                  <b-tabs
                    justified
                    nav-class="nav-tabs-custom"
                    content-class="p-3 text-muted"
                  >
                    <!--  Guest Experience -->
                    <b-tab active>
                      <template v-slot:title>
                        <span class="d-inline-block d-sm-none">
                          <i class="fas fa-home"></i>
                        </span>
                        <span class="d-none d-sm-inline-block"
                          >Guest Experience</span
                        >
                      </template>
                      <div class="row mt-1">
                        <div
                          class="col-md-12"
                          v-for="(guest, index) in guestExperiences"
                          :key="index"
                        >
                          <div class="card bg-light card-border">
                            <div class="card-body">
                              <div class="row">
                                <div class="col-md-1">
                                  <div
                                    class="form-check form-switch form-switch-md my-2"
                                  >
                                    <input
                                      class="form-check-input"
                                      type="checkbox"
                                      checked
                                      v-model="guest.is_active"
                                      @click="
                                        editGuestExperience({
                                          id: guest.id,
                                          is_active: guest.is_active,
                                          identity: 'switch',
                                        })
                                      "
                                    />
                                  </div>
                                </div>
                                <div class="col-md-11">
                                  <h4>
                                    {{
                                      guest.checkin_guest_experience.page_name
                                    }}
                                    <i
                                      class="fa fa-info-circle fa-xs text-muted ms-2"
                                      v-b-popover.hover.top="
                                        guest.checkin_guest_experience
                                          .page_tooltip
                                      "
                                      :key="guest.id"
                                    ></i>
                                    <i
                                      v-b-modal.modal-center
                                      class="fas fa-eye text-muted fa-xs ms-2"
                                      @click="
                                        openModelForGuestExperienceImage(
                                          guest.checkin_guest_experience
                                            .page_checkin_preview
                                        )
                                      "
                                    >
                                    </i>
                                  </h4>
                                  <div
                                    class="chip_list"
                                    id="chip_list_71677c05-04b9-49a0-9633-3d695e0d3b78"
                                  >
                                    <div
                                      class="chip m-1"
                                      v-for="bookingSource in guest.booking_source"
                                      :key="bookingSource.id"
                                      :id="bookingSource.id"
                                    >
                                      {{ bookingSource.name }}
                                      <span
                                        :id="bookingSource.id"
                                        class="close closebtn cursor"
                                        @click="
                                          editGuestExperience({
                                            id: guest,
                                            bookingSourceId: bookingSource.id,
                                          });
                                          guest.booking_source =
                                            guest.booking_source.filter(
                                              (item) => item !== bookingSource
                                            );
                                        "
                                        >×</span
                                      >
                                    </div>
                                    <button
                                      class="chip text-primary"
                                      id="add_new_booking"
                                      v-b-modal.modal-standard
                                      @click="
                                        openModelForGuestExperience(guest)
                                      "
                                    >
                                      + Add New Booking
                                    </button>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </b-tab>

                    <!-- Custom Question -->
                    <b-tab>
                      <template v-slot:title>
                        <span class="d-inline-block d-sm-none">
                          <i class="far fa-user"></i>
                        </span>
                        <span class="d-none d-sm-inline-block"
                          >Custom Question</span
                        >
                      </template>
                      <div class="container">
                        <div class="row mb-3">
                          <div class="col-lg-6">
                            <b-form-group
                              class="mb-3"
                              label="Title"
                              label-for="Title-input"
                            >
                              <b-form-input
                                id="Title-input"
                                v-model="hotel.custom_question_title"
                                type="text"
                                autocomplete="off"
                                @blur="updateTitle"
                                placeholder="Additional Details"
                              ></b-form-input>
                            </b-form-group>
                            <b-form-group
                              class="mb-3"
                              label="Sub-title"
                              label-for="subtitle-input"
                            >
                              <b-form-input
                                id="subtitle-input"
                                v-model="hotel.custom_question_sub_title"
                                type="text"
                                autocomplete="off"
                                @blur="updateTitle"
                                placeholder="Please fill question answer fot hostel use."
                              ></b-form-input>
                            </b-form-group>
                          </div>
                        </div>

                        <draggable
                          v-model="customQuestions"
                          @change="
                            (e) => {
                              onChoose(e);
                            }
                          "
                        >
                          <div
                            class="row"
                            v-for="(customeQuestion, index) in customQuestions"
                            :key="index"
                          >
                            <div class="col-6">
                              <b-card
                                header-class="bg-transparent"
                                class="cursor-move"
                              >
                                <h5 class="card-title mt-0">
                                  {{ index + 1 }}.
                                  {{ customeQuestion.question_text }}
                                  <span
                                    class="text-danger"
                                    v-if="customeQuestion.is_required"
                                    >*</span
                                  >
                                  <span class="text-end float-end">
                                    <a
                                      :id="String(index)"
                                      href="javascript:void(0)"
                                      v-b-popover.hover.top="
                                        'Edit custom question.'
                                      "
                                      @click="
                                        editCustomQuestion(
                                          customeQuestion,
                                          index
                                        )
                                      "
                                      ><i
                                        class="fas fa-pencil-alt text-success"
                                      ></i
                                    ></a>
                                    <a
                                      :id="String(index)"
                                      href="javascript:void(0)"
                                      v-b-popover.hover.top="
                                        'Delete custom question.'
                                      "
                                      @click="
                                        deleteCustomQuestion(
                                          customeQuestion.id,
                                          index
                                        )
                                      "
                                      ><i
                                        class="mdi mdi-trash-can ms-2 fs-5 text-danger"
                                      ></i
                                    ></a>
                                  </span>
                                </h5>
                                <div
                                  class="row card-text"
                                  v-if="
                                    customeQuestion.answer_type == 'date' ||
                                    customeQuestion.answer_type == 'time' ||
                                    customeQuestion.answer_type == 'number' ||
                                    customeQuestion.answer_type == 'time' ||
                                    customeQuestion.answer_type == 'phone' ||
                                    customeQuestion.answer_type == 'email' ||
                                    customeQuestion.answer_type == 'text' ||
                                    customeQuestion.answer_type == 'file'
                                  "
                                >
                                  <div class="col-md-12">
                                    <input
                                      :type="customeQuestion.answer_type"
                                      class="form-control form-control-sm"
                                      readonly
                                      :required="customeQuestion.is_required"
                                    />
                                  </div>
                                </div>
                                <div
                                  class="row card-text"
                                  v-if="
                                    customeQuestion.answer_type == 'textarea'
                                  "
                                >
                                  <div class="col-md-12">
                                    <textarea
                                      class="form-control form-control-sm"
                                      cols="5"
                                      :required="customeQuestion.is_required"
                                      rows="5"
                                    ></textarea>
                                  </div>
                                </div>
                                <div
                                  class="row card-text"
                                  v-if="customeQuestion.answer_type == 'radio'"
                                >
                                  <div class="col-md-12">
                                    <b-form-group>
                                      <b-form-radio
                                        :id="String(index)"
                                        class="mb-2"
                                        value="a"
                                        name="selectOption"
                                        plain
                                        >Yes</b-form-radio
                                      >
                                      <b-form-radio
                                        :id="String(index)"
                                        name="selectOption"
                                        value="b"
                                        plain
                                        >No
                                      </b-form-radio>
                                    </b-form-group>
                                  </div>
                                </div>
                                <div
                                  class="row card-text"
                                  v-if="
                                    customeQuestion.answer_type ==
                                      'multi_select' ||
                                    customeQuestion.answer_type == 'choice'
                                  "
                                >
                                  <div
                                    class="col-md-12"
                                    v-for="(
                                      customeCheckbox, index
                                    ) in customeQuestion.form_data"
                                    :key="index"
                                  >
                                    <b-form-checkbox
                                      value="accepted"
                                      unchecked-value="not_accepted"
                                      class="mb-2"
                                      checked
                                      plain
                                      >{{
                                        customeCheckbox.option
                                      }}</b-form-checkbox
                                    >
                                  </div>
                                </div>
                              </b-card>
                            </div>
                          </div>
                        </draggable>

                        <button
                          type="button"
                          class="btn btn-primary"
                          @click="customQuestionDrawer"
                        >
                          + Add Another
                        </button>
                      </div>
                    </b-tab>

                    <!-- Terms & Conditions -->
                    <b-tab>
                      <template v-slot:title>
                        <span class="d-inline-block d-sm-none">
                          <i class="far fa-envelope"></i>
                        </span>
                        <span class="d-none d-sm-inline-block"
                          >Terms & Conditions</span
                        >
                      </template>
                      <div class="row">
                        <div class="col-12">
                          <b-button
                            variant="primary"
                            class="float-end"
                            @click="newTermsForm"
                          >
                            Add New Terms
                          </b-button>
                        </div>
                        <div class="col-12 mt-2">
                          <div class="mb-0">
                            <!-- Table -->
                            <div class="table-responsive mb-0">
                              <table
                                class="table table-hover mb-0"
                                ref="my-table"
                                v-infinite-scroll="getTerms"
                                infinite-scroll-disabled="busy"
                                infinite-scroll-distance="10"
                              >
                                <thead class="table-light">
                                  <tr>
                                    <th>Internal Name</th>
                                    <th>Title Text</th>
                                    <th class="d-flex align-items-center">
                                      Policy Type
                                      <i
                                        class="fas fa-search text-end float-end mt-1 px-2"
                                        @click="openTermsFilter"
                                        v-if="viewTermsFilter == false"
                                      ></i>
                                      <div
                                        class="col-md-4 px-2"
                                        v-if="viewTermsFilter"
                                      >
                                        <select
                                          name="policy_type"
                                          class="form-control text-dark"
                                          id="policy_type"
                                          @change="filterTermsData()"
                                          v-model="termFilter.policy_type"
                                        >
                                          <option value="all">All</option>
                                          <option value="wifi_portal">
                                            Wifi Portal
                                          </option>
                                          <option value="kiosk_portal">
                                            Kiosk Portal
                                          </option>
                                          <option value="lock_portal">
                                            Lock Portal
                                          </option>
                                          <option value="guest_portal">
                                            Guest Portal
                                          </option>
                                          <option value="checkin_portal">
                                            Checkin Portal
                                          </option>
                                        </select>
                                      </div>
                                    </th>
                                    <th>Status</th>
                                    <th>Action</th>
                                  </tr>
                                </thead>
                                <tbody v-if="is_terms_data_loading">
                                  <tr v-for="(item, index) in 5" :key="index">
                                    <td
                                      class="placeholder-glow"
                                      v-for="no in 5"
                                      :key="no"
                                    >
                                      <span
                                        class="placeholder w-100 placeholder-lg"
                                      ></span>
                                    </td>
                                  </tr>
                                </tbody>
                                <tbody v-else>
                                  <tr
                                    v-for="(data, index) in termsTable.table
                                      .tableData"
                                    :key="index"
                                    class="text-capitalize"
                                  >
                                    <td
                                      @click="editTerms(data)"
                                      style="width: 300px"
                                    >
                                      {{
                                        data.internal_name.replaceAll("_", " ")
                                      }}
                                    </td>
                                    <td @click="editTerms(data)">
                                      {{ data.title_text }}
                                    </td>
                                    <td @click="editTerms(data)">
                                      {{
                                        data.policy_type.replaceAll("_", " ")
                                      }}
                                    </td>
                                    <td>
                                      <div class="form-check form-switch my-2">
                                        <input
                                          class="form-check-input"
                                          type="checkbox"
                                          v-model="data.is_publish"
                                          @change="
                                            changeTermsStatus({
                                              id: data.id,
                                              is_publish: data.is_publish,
                                            })
                                          "
                                        />
                                      </div>
                                    </td>
                                    <td>
                                      <div class="d-flex align-items-center">
                                        <i
                                          class="fas fa-pencil-alt text-success mx-1"
                                          v-b-popover.hover="'Edit record'"
                                          id="edit"
                                          @click="editTerms(data)"
                                        ></i>
                                        <i
                                          v-if="data.is_deleted"
                                          class="mdi mdi-trash-can mx-1 fs-5 text-danger"
                                          v-b-popover.hover="'Delete record'"
                                          id="delete"
                                          @click="deleteTerms(data.id)"
                                        ></i>
                                      </div>
                                    </td>
                                  </tr>
                                </tbody>
                                <tbody
                                  v-if="
                                    !is_terms_data_loading &&
                                    termsTable.table.length == 0
                                  "
                                >
                                  <tr>
                                    <td colspan="9" class="text-center">
                                      <img
                                        src="@/assets/images/empty.svg"
                                        class="img-fluid"
                                        alt=""
                                      />
                                      <p>
                                        <span class="text-secondary"
                                          >No Data Found</span
                                        >
                                      </p>
                                    </td>
                                  </tr>
                                </tbody>
                              </table>
                            </div>
                          </div>
                        </div>
                      </div>
                    </b-tab>
                  </b-tabs>
                </b-card-text>
              </b-card-body>
            </b-collapse>
          </b-card>
          <!--End check-in policy section -->

          <b-card no-body class="mb-3 d-none">
            <b-card-header header-tag="header" role="tab" v-b-toggle.taxes>
              <h6 class="my-1">
                <a class="text-dark" href="javascript: void(0);">Tax Policy</a>
              </h6>
            </b-card-header>
            <b-collapse id="taxes" visible accordion="my-accordion">
              <b-card-body>
                <b-card-text>
                  <Taxes :currentProps="taxesProps" />
                </b-card-text>
              </b-card-body>
            </b-collapse>
          </b-card>
        </div>
      </div>
    </div>

    <!-- The model is for add new pmd based on hotel -->
    <b-modal
      id="pms-modal"
      centered
      title="Add New PMS"
      title-class="font-18"
      hide-footer
      @hidden="resetPmsModal"
    >
      <form ref="form" @submit.stop.prevent="handlePmsSubmit">
        <div class="row">
          <div class="col-12">
            <b-form-group label="Login URL" label-for="login_url" class="mb-3">
              <span slot="label"
                >Login URL <span class="text-danger">*</span></span
              >
              <b-form-input
                id="login_url"
                v-model.trim="pmsData.login_url"
                type="text"
                autocomplete="off"
                placeholder="Enter PMS login url"
                :class="{
                  'is-invalid': pmdFormSubmitted && $v.pmsData.login_url.$error,
                }"
              ></b-form-input>
              <div v-if="pmdFormSubmitted" class="invalid-feedback">
                <span v-if="!$v.pmsData.login_url.required"
                  >Login URL is required.</span
                >
              </div>
            </b-form-group>
            <b-form-group
              label="Customer Code"
              label-for="customer_code"
              class="mb-3"
            >
              <span slot="label"
                >Customer Code <span class="text-danger">*</span></span
              >
              <b-form-input
                id="customer_code"
                v-model.trim="pmsData.customer_code"
                type="text"
                autocomplete="off"
                placeholder="Enter PMS Customer Code"
                :class="{
                  'is-invalid':
                    pmdFormSubmitted && $v.pmsData.customer_code.$error,
                }"
              ></b-form-input>
              <div v-if="pmdFormSubmitted" class="invalid-feedback">
                <span v-if="!$v.pmsData.customer_code.required"
                  >Customer Code is required.</span
                >
              </div>
            </b-form-group>
          </div>
          <div class="col-6">
            <b-form-group label="User Name" label-for="user_name" class="mb-3">
              <span slot="label"
                >User Name <span class="text-danger">*</span></span
              >
              <b-form-input
                id="user_name"
                v-model.trim="pmsData.user_name"
                type="text"
                autocomplete="off"
                placeholder="Enter PMS User Name"
                :class="{
                  'is-invalid': pmdFormSubmitted && $v.pmsData.user_name.$error,
                }"
              ></b-form-input>
              <div v-if="pmdFormSubmitted" class="invalid-feedback">
                <span v-if="!$v.pmsData.user_name.required"
                  >User Name is required.</span
                >
              </div>
            </b-form-group>
          </div>
          <div class="col-6">
            <b-form-group label="Password" label-for="password" class="mb-3">
              <span slot="label"
                >Password <span class="text-danger">*</span></span
              >
              <b-form-input
                id="password"
                v-model.trim="pmsData.password"
                type="text"
                autocomplete="off"
                placeholder="Enter PMS Password"
                :class="{
                  'is-invalid': pmdFormSubmitted && $v.pmsData.password.$error,
                }"
              ></b-form-input>
              <div v-if="pmdFormSubmitted" class="invalid-feedback">
                <span v-if="!$v.pmsData.password.required"
                  >Password is required.</span
                >
              </div>
            </b-form-group>
          </div>
        </div>
        <div>
          <div class="col-12">
            <b-button
              variant="outline-primary"
              class="me-2 float-end"
              type="reset"
              @click="resetPmsModal"
              >Cancel
            </b-button>
            <b-button
              variant="outline-primary"
              class="me-2 float-end"
              type="submit"
              @click="handlePmsOk"
              :class="{ disabled: isPmsBtnLoading }"
            >
              <i
                class="bx bx-loader bx-spin font-size-16 align-middle me-2"
                v-if="isPmsBtnLoading"
              ></i>
              Save
            </b-button>
          </div>
        </div>
      </form>
    </b-modal>

    <!-- The model is for add new booking source based on hotel -->
    <b-modal
      id="source-modal"
      centered
      :title="bookingSource.title"
      title-class="font-18"
      hide-footer
      @hidden="resetModal"
    >
      <form ref="form" @submit.stop.prevent="handleSubmit">
        <div class="row">
          <div class="col-12">
            <b-form-group label="Booking Source Name" label-for="name-input">
              <span slot="label"
                >Booking Source Name <span class="text-danger">*</span></span
              >
              <b-form-input
                id="name-input"
                v-model="bookingSource.name"
                type="text"
                autocomplete="off"
                placeholder="Booking Source Name"
                :class="{
                  'is-invalid':
                    (bookingSourceFormSubmitted &&
                      $v.bookingSource.name.$error) ||
                    bookingSourceFormSubmittedError,
                }"
              ></b-form-input>
              <div
                v-if="
                  bookingSourceFormSubmitted || bookingSourceFormSubmittedError
                "
                class="invalid-feedback"
              >
                <span v-if="!$v.bookingSource.name.required"
                  >Booking source name is required.</span
                >
                <span v-if="bookingSourceFormSubmittedError"
                  >Booking source name is must be unique.</span
                >
              </div>
            </b-form-group>
          </div>
          <div class="col-12 mt-2 d-none">
            <b-form-group
              class="mb-3"
              label="Profile Picture"
              label-for="booking-source-image-input"
            >
              <b-form-file
                class="form-control"
                id="booking-source-image-input"
                plain
                v-model="bookingSource.image"
              >
              </b-form-file>
            </b-form-group>
          </div>
        </div>
        <div>
          <div class="col-12 mb-3">
            <b-button
              variant="outline-primary"
              class="me-2 float-end"
              type="reset"
              @click="
                () => {
                  this.$bvModal.hide('source-modal');
                }
              "
              >Cancel</b-button
            >
            <b-button
              variant="outline-primary"
              class="me-2 float-end"
              type="submit"
              @click="handleOk"
              :class="{ disabled: is_btn_loading }"
            >
              <i
                class="bx bx-loader bx-spin font-size-16 align-middle me-2"
                v-if="is_btn_loading"
              ></i>
              {{ bookingSource.edit ? "Update" : "Save" }}
            </b-button>
          </div>
        </div>
      </form>
    </b-modal>

    <!-- The model is for view image of guest experience -->
    <b-modal
      v-if="openGuestExperienceImageModal"
      id="modal-center"
      centered
      hide-footer
      title="Image Preview For Mobile Side"
    >
      <img
        v-if="guestExperienceImage ? guestExperienceImage : 'Image Preview'"
        :src="guestExperienceImage"
        alt=""
        width="200"
        class="rounded mx-auto d-block border-top-0"
      />
    </b-modal>

    <!-- The model is for select booking source in  guest experience-->
    <b-modal
      v-if="openGuestExperienceForm"
      id="modal-standard"
      centered
      hide-footer
      @hidden="hiddenData"
      @cancel="hiddenData"
    >
      <div class="form-group">
        <div class="row">
          <label for="booking_source"
            >Select Booking Source
            <span class="m-2">
              <b-button
                id="Attach All"
                size="sm"
                variant="primary"
                @click="attachAll"
                >Attach All</b-button
              >
            </span>
            <b-button
              id="Detach All"
              size="sm"
              variant="primary"
              @click="
                () => {
                  tempGuestExp = [];
                }
              "
              >Detach All</b-button
            >
          </label>
        </div>
        <multiselect
          v-if="guestExperience.id"
          v-model="tempGuestExp"
          track-by="name"
          label="name"
          placeholder="Select Booking Sources"
          :options="guestExperienceOptions"
          :multiple="true"
          :taggable="true"
          :class="{ 'is-invalid': errorMessage }"
          :show-labels="false"
        >
          <template slot="singleLabel" slot-scope="{ option }">
            <strong :id="option.id"> {{ option.name }}</strong>
          </template>
        </multiselect>
        <div v-if="errorMessage" class="invalid-feedback">
          <span v-if="errorMessage">{{ errorMessage }}</span>
        </div>
        <div>
          <div class="col-12 mb-3">
            <b-button
              class="float-end ms-2"
              variant="outline-primary"
              type="reset"
              @click="openGuestExperienceForm = false"
              >Cancel</b-button
            >
            <b-button
              variant="outline-primary"
              class="float-end"
              type="submit"
              @click="
                editGuestExperience({
                  id: guestExperience.id,
                  booking_source: tempGuestExp,
                  identity: 'addNew',
                })
              "
              :class="{ disabled: is_btn_loading }"
            >
              <i
                class="bx bx-loader bx-spin font-size-16 align-middle"
                v-if="is_btn_loading"
              ></i>
              Add Booking Source
            </b-button>
          </div>
        </div>
      </div>
    </b-modal>

    <!-- Payment policy drawer -->
    <Drawer
      @close="newPaymentPolicyForm"
      :align="'right'"
      :closeable="true"
      :maskClosable="true"
      :zIndex="1002"
    >
      <div v-if="openPaymentPolicyForm">
        <PaymentPolicy
          :currentProps="paymentPolicyProps"
          @submitted="policyChanged"
          @cancelSubmit="newPaymentPolicyForm"
        />
      </div>
    </Drawer>

    <!-- Terms and condition drawer -->
    <Drawer
      @close="newTermsForm"
      :align="'right'"
      :closeable="true"
      :maskClosable="true"
      :zIndex="1002"
    >
      <div v-if="openNewTermsForm">
        <Terms
          :currentProps="termsProps"
          @submitted="termCreated"
          @cancelSubmit="newTermsForm"
          @saveAndAddNew="saveAndAddNewTerms"
        />
      </div>
    </Drawer>

    <!-- Custom Question drawer -->
    <Drawer
      @close="customQuestionDrawer"
      :align="'right'"
      :closeable="true"
      :maskClosable="true"
      :zIndex="1002"
    >
      <div v-if="isShowCustomQuestion">
        <div class="offcanvas-body text-black">
          <CustomQuestion
            :currentProps="questionProps"
            @submitted="questionAdded"
            @cancelSubmit="customQuestionDrawer"
            @saveAndAddNew="saveAndAddNewCustomQuestions"
          ></CustomQuestion>
        </div>
      </div>
    </Drawer>
  </div>
</template>

<style scoped>
.custom-card-height {
  min-height: 250px;
}

.chip {
  display: inline-block;
  padding: 0 12px;
  height: 25px;
  font-size: 12px;
  line-height: 22px;
  border-radius: 25px;
  background-color: #f3f7f9;
  color: #888888;
  border: 0.5px solid #8c8c8d;
}

.closebtn {
  padding-left: 10px;
  color: #888;
  font-weight: bold;
  float: right;
  font-size: 20px;
}

.closebtn:hover {
  color: #000;
}
</style>
